module.exports = __webpack_public_path__ + "img/ESTP.d9371bb4.png";